<template>

</template>

<script setup>
import { computed, onMounted, watch, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  wordName: {
    type: String,
    required: true,
  },
});

const store = useStore();
const wordData = computed(() => store.getters.getDocumentById(props.wordName));

let context;
let canvas;

watch(
  () => props.pdfName,
  (n, o) => {
    try{

      clearCanvas();
      loadWordDefault();

    }
    catch(e){
      console.error(e);     
    }
  }
);

function clearCanvas() {
  context?.clearRect(0, 0, canvas.width, canvas.height);
}

function downloadFile(blob, filename) {
    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create an anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // Append the anchor to the body (required for Firefox)
    document.body.appendChild(a);

    // Programmatically click the anchor to trigger the download
    a.click();

    // Remove the anchor from the document
    document.body.removeChild(a);

    // Revoke the Blob URL
    URL.revokeObjectURL(url);
}


function loadWordDefault() {

  if (!wordData.value) return;

  console.log("📕 ~ loadWordDefault ~", props.wordName);

  const reader = new FileReader();
  reader.readAsDataURL(wordData.value.FileBytes);
  reader.onloadend = function () {
    const base64data = reader.result;
    console.log("base64data:", base64data);

    // Ensure the Base64 string is correctly extracted
    const base64string = base64data.split(",")[1];
    console.log("base64string:", base64string);

    // Decode the Base64 string
    const binaryString = atob(base64string);
    console.log("binaryString:", binaryString);

    // Convert binary string to Uint8Array
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    console.log("Uint8Array:", bytes);

    // Create a Blob from the Uint8Array
    const blob = new Blob([bytes], { type: 'application/msword' });
    const url = URL.createObjectURL(blob);
    console.log('Word URL: {}', url);
    // Open the PDF in a new tab
    window.open(url, '_blank');
  };
}

try{
  loadWordDefault();
}
catch(e){
  console.error(e);
}

onBeforeUnmount(() => {
  // Your function here...
  console.log("Component is about to be destroyed");
  if (context) {
    context.clearRect(0, 0, canvas.width, canvas.height);
    console.log("PDF removed and component is about to be destroyed");
  }
});
</script>
